import { baseUrl } from "./baseUrl";
export const getTrackingResults = (numbers) => {
    return fetch(`${baseUrl}tracking/?tracking_numbers=${numbers.join(",")}`);
};
